import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  tabItemStyle: (isSeeAll = false) => ({
    width: isSeeAll ? 58.12 : 83.84,
    height: 35.42,
    borderRadius: 26,
    marginRight: 13,
  }),
  tabsContainerStyle: {
    marginHorizontal: 2,
  },
  cardBodyItemContainer: {
    marginTop: 12,
    marginBottom: 20,
  },
  cardBodyItemCircle: {
    width: 35,
    height: 35,
    borderRadius: 35,
    marginRight: 17,
    marginTop: 8,
  },
  cardBodyItemSquare: {
    marginTop: 8,
    width: '100%',
    height: 14,
  },
  separator: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.divider,
    marginBottom: 26,
    marginTop: 27,
  }),
  title: {
    width: 181.25,
    height: 25,
  },
  subtitle: {
    width: 83.33,
    height: 16.67,
    marginTop: 10.42,
    marginBottom: 18.75,
  },
});
